import { render } from "./talRecordBox.vue?vue&type=template&id=6acda3b2"
import script from "./talRecordBox.vue?vue&type=script&lang=js"
export * from "./talRecordBox.vue?vue&type=script&lang=js"

import "./talRecordBox.vue?vue&type=style&index=0&id=6acda3b2&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__